import { makeStyles } from '@mui/styles'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeStyles(() => ({
    DataTableContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    DataTableWrapper: {
        width: '100%',
        border: `2px solid ${defaultPalette.lightGrey.dark}`,
        borderRadius: 12,
        overflow: 'hidden',
    },
    DataTableWrapperScroller: {
        width: '100%',
        overflow: 'auto',
    },
    DataTable: {},
    DataTableHead: {
        backgroundColor: '#ffffff',
        borderBottom: `1px solid ${defaultPalette.typography.main}`,
    },
    DataTableBody: {},
    DataTableRow: {
        background: '#ffffff',
        borderBottom: `1px solid ${defaultPalette.lightGrey.medium}`,
        '&:last-of-type': {
            borderBottom: '1px solid transparent',
        },
    },
    DataTableRowClickable: {
        cursor: 'pointer',
        '&:hover': {
            background: defaultPalette.lightGrey.main,
            '& .MuiTableCell-root': {
                textDecoration: 'underline',
            },
        },
    },
    DataTableRowOdd: {
        // background: theme.palette.lightGrey.main,
    },
    DataTableRowTooltip: {
        maxWidth: '30rem',
        backgroundColor: defaultPalette.typography.main,
        color: defaultPalette.lightGrey.lightest,
    },
    DataTableRowTooltipArrow: {
        color: defaultPalette.typography.main,
    },
    DataTableCell: {
        border: 'none',
        fontWeight: 600,
    },
    DataTableCellExtraSmall: {
        minWidth: '7rem',
    },
    DataTableCellSmall: {
        minWidth: '10rem',
    },
    DataTableCellMedium: {
        minWidth: '16rem',
    },
    DataTableCellLarge: {
        minWidth: '30rem',
    },
    DataTableCellStart: {
        textAlign: 'left',
    },
    DataTableCellCenter: {
        textAlign: 'center',
    },
    DataTableCellEnd: {
        textAlign: 'right',
    },
    DataTableHeaderCell: {
        padding: '1rem 1rem',
        fontWeight: 800,
    },
    DataTableBodyCell: {
        padding: '1rem 1rem',
        color: defaultPalette.typography.main,
        fontSize: '.9rem',
    },
    DataTableCellFirst: {},
    DataTableCellError: {},
    DataTableCellButton: {
        padding: '.5rem !important',
        fontSize: 'inherit',
    },
    DataTableCellButtonLabel: {
        textAlign: 'left',
        fontWeight: '800 !important',
    },
    DataTableCellContentWithIcon: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.5rem',
    },
    DataTableCellDocuments: {},
    DataTableCellIcon: {
        width: '1.5rem',
        height: '1.5rem',
    },
    DataTableCellDisabled: {
        opacity: 0.38,
        cursor: 'default',
        '& .MuiTableCell-root': {
            textDecoration: 'none !important',
        },
    },
    DataTableLoading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        gap: '1rem',
    },
    DataTablePagination: {
        width: '100%',
    },
    tableCellErrorNotification: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
    },
    tableCellErrorNotificationDot: {
        width: '9px',
        height: '9px',
        borderRadius: '100px',
        background: defaultPalette.orangeWarning.main,
    },
}))
